import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyBj_ART8hxD3t_lPn94YY6pfex9_gbEHDE',
  authDomain: 'pitchside-bc65b.firebaseapp.com',
  projectId: 'pitchside-bc65b',
  storageBucket: 'pitchside-bc65b.firebasestorage.app',
  messagingSenderId: '439027212368',
  appId: '1:439027212368:web:981b5a7cbe3efe909d7155',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');
